import type { ID } from '@octopus-do/octopus-project-core'
import type { AppState } from '@store/types'

import { findProjectParents } from '../utils'

export const selectProjectParents = (projectId: ID) => (state: AppState) =>
  findProjectParents(projectId, state.dashboard)
